// Login Api
export const LOGIN = "/admin/login";

// User Analytics Api
export const UPLOAD_PROFILE_PIC = "/admin/users/profilepic";
export const UPLOAD_AADHARCARD_PIC = "/admin/users/aadharcard";
export const ANALYTICS_LIST = "/admin/users";
export const ANALYTICS_ADDEDIT = "/admin/users/save";
export const ANALYTICS_GETONE = "/admin/users/getone";
export const ANALYTICS_CHANGE_STATUS = "/admin/users/changestatus";
export const ANALYTICS_DELETE = "/admin/users/delete";
export const LIST_DISTRICT = "/admin/districts";
export const LIST_TALUKA = "/admin/talukas";
export const LIST_VILLAGE = "/admin/villages";
export const FAMILY_LIST = "/admin/familymembers";
export const FAMILY_ADDEDIT = "/admin/familymembers/save";
export const FAMILY_GETONE = "/admin/familymembers/getone";
export const FAMILY_DELETE = "/admin/familymembers/delete";
export const USER_APPROVE_REJECT = "/admin/users/approve";
export const USER_REJECT = "/admin/users/reject";
export const USER_EXPORT = "/admin/users/userexport";
export const RESULT_EXPORT = "/admin/users/resultexport";

// Relation Api
export const RELATION_LIST = "/admin/relations";
export const RELATION_ADDEDIT = "/admin/relations/save";
export const RELATION_WOP_LIST = "/admin/relations";
export const RELATION_CHANGE_STATUS = "/admin/relations/changestatus";
export const RELATION_DELETE = "/admin/relations/delete";

// Send Message Api
export const UPLOAD_IMAGES = "/admin/messages/image";
export const MESSAGE_LIST = "/admin/messages";
export const MESSAGE_ADDEDIT = "/admin/messages/save";
export const MESSAGE_GETONE = "/admin/messages/getone";
export const MESSAGE_DELETE = "/admin/messages/delete";

// Gallery Api
export const UPLOAD_PHOTOS = "/admin/photos/uploadphoto";
export const GALLERY_LIST = "/admin/photos/";
export const GALLERY_ADDEDIT = "/admin/photos/save";
export const GALLERY_GETONE = "/admin/photos/getone";
export const GALLERY_DELETE = "/admin/photos/delete";

// Entertainments Api
export const ENTERTAINMENT_LIST = "/admin/entertainments";
export const ENTERTAINMENT_ADDEDIT = "/admin/entertainments/save";
export const ENTERTAINMENT_CHANGE_STATUS = "/admin/entertainments/changestatus";
export const ENTERTAINMENT_DELETE = "/admin/entertainments/delete";
export const ENTERTAINMENT_GETONE = "/admin/entertainments/getone";
export const ENTERTAINMENT_IMAGE_UPLOAD = "/admin/entertainments/upload";

// Committee Api
export const COMMITTEE_LIST = "/admin/committeemembers";
export const COMMITTEE_ADDEDIT = "/admin/committeemembers/save";
export const COMMITTEE_CHANGE_STATUS = "/admin/committeemembers/changestatus";
export const COMMITTEE_GETONE = "/admin/committeemembers/getone";
export const ALLUSER_LIST = "/admin/users";
export const ALLDESIGNATION_LIST = "/admin/usertypes/withoutPagination";
export const ALLDISTRICT_LIST = "/admin/districts";
export const ALLTALUKA_LIST = "/admin/talukas";
export const ALLVILLAGE_LIST = "/admin/villages";
export const COMMITTEE_DELETE = "/admin/committeemembers/delete";
export const COMMITTEE_EXPORT = "/admin/committeemembers/export";

// User type Api
export const USERTYPE_LIST = "/admin/usertypes";
export const USERTYPE_ADDEDIT = "/admin/usertypes/save";
export const USERTYPE_WOP_LIST = "/admin/usertypes/withoutPagination";
export const USERTYPE_CHANGE_STATUS = "/admin/usertypes/changestatus";
export const USERTYPE_DELETE = "/admin/usertypes/delete";

// Village Api
export const VILLAGE_LIST = "/admin/villages";
export const VILLAGE_ADDEDIT = "/admin/villages/save";
export const VILLAGE_WOP_LIST = "/admin/villages";
export const VILLAGE_CHANGE_STATUS = "/admin/villages/changestatus";
export const VILLAGE_DELETE = "/admin/villages/delete";

// Taluka Api
export const TALUKA_LIST = "/admin/talukas";
export const TALUKA_ADDEDIT = "/admin/talukas/save";
export const TALUKA_WOP_LIST = "/admin/talukas";
export const TALUKA_CHANGE_STATUS = "/admin/talukas/changestatus";
export const TALUKA_DELETE = "/admin/talukas/delete";

// District Api
export const DISTRICT_LIST = "/admin/districts";
export const DISTRICT_ADDEDIT = "/admin/districts/save";
export const DISTRICT_WOP_LIST = "/admin/districts";
export const DISTRICT_CHANGE_STATUS = "/admin/districts/changestatus";
export const DISTRICT_DELETE = "/admin/districts/delete";

// Occupation Api
export const OCCUPATION_LIST = "/admin/occupations";
export const OCCUPATION_ADDEDIT = "/admin/occupations/save";
export const OCCUPATION_WOP_LIST = "/admin/occupations";
export const OCCUPATION_CHANGE_STATUS = "/admin/occupations/changestatus";
export const OCCUPATION_DELETE = "/admin/occupations/delete";

// Education Api
export const EDUCATION_LIST = "/admin/educations";
export const EDUCATION_ADDEDIT = "/admin/educations/save";
export const EDUCATION_WOP_LIST = "/admin/educations";
export const EDUCATION_CHANGE_STATUS = "/admin/educations/changestatus";
export const EDUCATION_DELETE = "/admin/educations/delete";

// Fund Api
export const FUND_LIST = "/admin/funds/withpagination";
export const FUND_ADDEDIT = "/admin/funds/save";
export const FUND_WOP_LIST = "/admin/funds/withoutpagination";
export const FUND_CHANGE_STATUS = "/admin/funds/changestatus";
export const FUND_DELETE = "/admin/funds/delete";

// Donators Api
export const DONATOR_LIST = "/admin/donators";
export const DONATOR_ADDEDIT = "/admin/donators/save";
export const DONATOR_CHANGE_STATUS = "/admin/donators/changestatus";
export const DONATOR_DELETE = "/admin/donators/delete";
export const DONATOR_EXPORT = "/admin/donators/export";

// Year Api
export const YEAR_ADDEDIT = "/admin/year/save";
export const YEAR_WOP_LIST = "/admin/year";
export const YEAR_DELETE = "/admin/year/delete";

// Award Api
export const AWARD_LIST = "/admin/awards/withpagination";
export const AWARD_ADDEDIT = "/admin/awards/save";
export const AWARD_WOP_LIST = "/admin/awards/withoutpagination";
export const AWARD_CHANGE_STATUS = "/admin/awards/changestatus";
export const AWARD_DELETE = "/admin/awards/delete";

// Honored Api
export const HONORED_LIST = "/admin/honored/withpagination";
export const HONORED_ADDEDIT = "/admin/honored/save";
export const HONORED_CHANGE_STATUS = "/admin/honored/changestatus";
export const HONORED_DELETE = "/admin/honored/delete";

// Result Api
export const RESULT_LIST = "/admin/results";
export const RESULT_APPROVE_REJECT = "/admin/results/approve";
export const RESULT_GETONE = "/admin/results/getone";
export const RESULT_ALLOW_EDIT = "/admin/results/allowedit";

// Settings Api
export const SETTINGS_GET = "/admin/settings";
export const SETTINGS_SAVE = "/admin/settings";

